// src/components/HeaderBar.jsx

import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Badge,
  Menu,
  MenuItem as DropdownItem,
  ListItemText,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot, updateDoc } from "firebase/firestore";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonIcon from "@mui/icons-material/Person";
import StarIcon from "@mui/icons-material/Star";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useTheme } from "@mui/material/styles";
import { deleteDoc } from "firebase/firestore";
import { Divider } from "@mui/material";

import { getApp } from "firebase/app";
import {
  getStripePayments,
  getCurrentUserSubscriptions,
} from "@invertase/firestore-stripe-payments";
import SearchIcon from "@mui/icons-material/Search";

const stripeApp = getApp();
const stripePayments = getStripePayments(stripeApp, {
  productsCollection: "products",
  customersCollection: "customers",
});
console.log("💳 StripePayments (HeaderBar) initialized:", stripePayments);

export default function HeaderBar({
  title,
  projects = [],
  selectedProject,
  onProjectChange,
  onAddProjectClick,
  showProjectSelect = true,
  userRole,
  showAddProjectButton = false,
  addProjectDisabled = false,
  addProjectTooltip = "",
  addProjectCtaLabel,
  onAddProjectCta,
  children,
  showSearch = false, // ⬅️ afficher la barre ?
  searchValue = "", // ⬅️ valeur contrôlée
  onSearchChange = () => {},
}) {
  const theme = useTheme();
  const { translate } = useContext(LanguageContext);
  const { currentUser, logOut } = useAuth();
  const [photoUrl, setPhotoUrl] = useState(null);
  const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.filter((n) => !n.read).length;
  const [nameProfile, setNameProfile] = useState(null);
  const handleProfileClick = (e) => setAnchorProfile(e.currentTarget);
  const handleProfileClose = () => setAnchorProfile(null);
  const [anchorProfile, setAnchorProfile] = useState(null);
  const [isPremium, setIsPremium] = useState(false);

  // Vérifie si l'utilisateur a un abo actif

  const clearReadNotifications = async () => {
    if (!currentUser) return;
    const toDelete = notifications.filter((n) => n.read);
    await Promise.all(
      toDelete.map((n) =>
        deleteDoc(
          doc(db, "profilsUsers", currentUser.uid, "notifications", n.id)
        )
      )
    );
  };

  useEffect(() => {
    if (!currentUser) return;
    getCurrentUserSubscriptions(stripePayments, { status: "active" })
      .then((subs) => setIsPremium(subs.length > 0))
      .catch((e) => console.error("HeaderBar subs error:", e));
  }, [currentUser]);

  // Souscription Firestore
  useEffect(() => {
    if (!currentUser) return;
    const notifCol = collection(
      db,
      "profilsUsers",
      currentUser.uid,
      "notifications"
    );
    const unsub = onSnapshot(notifCol, (snap) => {
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, [currentUser]);

  const handleBellClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleBellClose = () => {
    setAnchorEl(null);
  };

  // Marquer une notification comme lue
  const markAsRead = async (nid) => {
    await updateDoc(
      doc(db, "profilsUsers", currentUser.uid, "notifications", nid),
      {
        read: true,
      }
    );
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!currentUser?.uid) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "profilsUsers", currentUser.uid));
        if (snap.exists()) {
          setPhotoUrl(snap.data().photoUrl);
          setNameProfile(snap.data().name);
        }
      } catch (e) {
        console.error("Erreur chargement photo profil :", e);
      }
    })();
  }, [currentUser]);

  // Trie par date décroissante
  const sortedNotifications = [...notifications].sort(
    (a, b) => b.timestamp.seconds - a.timestamp.seconds
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: "30px",
        paddingBottom: "0px",
        paddingRight: "50px",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        alignContent: "center",
        height: "8%",
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Titre / Sous-titre */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "40px",
        }}
      >
        <Box>
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              height: "100%",
              color: theme.palette.text.primary,
            }}
          >
            {translate("Welcome")}, {nameProfile}!
          </div>
        </Box>

        {showProjectSelect && (
          <FormControl size="small" sx={{ minWidth: 200, mr: 2 }}>
            {/* 1. Le label du sélecteur */}
            <InputLabel id="project-select-label">
              {translate("ChooseAProject")}
            </InputLabel>

            <Select
              labelId="project-select-label"
              id="project-select"
              value={selectedProject || ""}
              label={translate("ChooseAProject")}
              onChange={(e) => {
                if (e.target.value === "__add") onAddProjectClick();
                else onProjectChange(e.target.value);
              }}
              sx={{
                bgcolor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              }}
              displayEmpty
              renderValue={(value) => {
                if (!value) {
                  return (
                    <span style={{ color: theme.palette.text.secondary }}>
                      {translate("ChooseAProject")}
                    </span>
                  );
                }
                const p = projects.find((proj) => proj.id === value);
                return p ? p.name : "";
              }}
            >
              {/* 3. Tes projets */}
              {projects.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.name}
                </MenuItem>
              ))}

              {/* 4. Option “Ajouter” */}
              {userRole === "Admin" && !addProjectDisabled && (
                <MenuItem value="__add">
                  <Add /> {translate("AddAProject")}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}

        {/* 🔎 Barre de recherche (Premium uniquement) */}
        {isPremium && showSearch && (
          <Box sx={{ minWidth: 280, mr: 2 }}>
            <TextField
              fullWidth
              size="small"
              placeholder={translate("SearchTicketsPlaceholder")}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  "& fieldset": { borderColor: theme.palette.divider },
                  "&:hover fieldset": { borderColor: theme.palette.divider },
                  "&.Mui-focused fieldset": {
                    borderColor: theme.palette.primary.main,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}

        {showAddProjectButton && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}>
            <Tooltip
              title={addProjectDisabled ? addProjectTooltip : ""}
              placement="bottom"
            >
              <span>
                <Button
                  variant="outlined"
                  onClick={onAddProjectClick}
                  startIcon={<Add />}
                  disabled={addProjectDisabled}
                >
                  {translate("AddAProject")}
                </Button>
              </span>
            </Tooltip>
            {addProjectDisabled && addProjectCtaLabel && onAddProjectCta && (
              <Button
                variant="text"
                size="small"
                onClick={onAddProjectCta}
                sx={{ textTransform: "none", fontWeight: 700 }}
              >
                {addProjectCtaLabel}
              </Button>
            )}
          </Box>
        )}

        {children}
      </div>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {/* Cloche de notification */}
        <IconButton onClick={handleBellClick}>
          <Badge badgeContent={unreadCount} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleBellClose}
          PaperProps={{
            style: {
              maxHeight: "50vh",
              width: 320,
              overflowY: "auto",
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
          }}
        >
          {sortedNotifications.length === 0 ? (
            <DropdownItem disabled>
              <ListItemText primary={translate("NoNotifications")} />
            </DropdownItem>
          ) : (
            sortedNotifications.map((n) => (
              <DropdownItem
                key={n.id}
                selected={!n.read}
                onClick={async () => {
                  await markAsRead(n.id);

                  handleBellClose();
                  if (n.projectId && n.ticketId) {
                    navigate(
                      `/app/projects/${encodeURIComponent(
                        n.projectId
                      )}/tickets/${encodeURIComponent(n.ticketId)}`
                    );
                  } else if (n.link) {
                    navigate(
                      n.link.startsWith("/app") ? n.link : `/app${n.link}`
                    );
                  }
                }}
                sx={{
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  "&:last-of-type": { borderBottom: "none" },
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                  // réduit la hauteur si nécessaire
                  alignItems: "flex-start",
                }}
              >
                <ListItemText
                  primary={n.message}
                  secondary={new Date(
                    n.timestamp.seconds * 1000
                  ).toLocaleString()}
                  primaryTypographyProps={{
                    noWrap: false,
                    sx: { whiteSpace: "normal", overflowWrap: "break-word" },
                  }}
                  secondaryTypographyProps={{
                    noWrap: false,
                    sx: { whiteSpace: "normal" },
                  }}
                />
              </DropdownItem>
            ))
          )}
          {sortedNotifications.some((n) => n.read) && (
            <>
              <Divider />
              <DropdownItem onClick={clearReadNotifications}>
                <ListItemText primary={translate("ClearReadNotifications")} />
              </DropdownItem>
            </>
          )}
        </Menu>

        {photoUrl && (
          <Button
            onClick={handleProfileClick}
            startIcon={
              isPremium ? (
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <StarIcon sx={{ color: "gold", fontSize: 14 }} />
                  }
                >
                  <Avatar
                    src={photoUrl}
                    alt={nameProfile}
                    sx={{ width: 32, height: 32 }}
                  />
                </Badge>
              ) : (
                <Avatar
                  src={photoUrl}
                  alt={nameProfile}
                  sx={{ width: 32, height: 32 }}
                />
              )
            }
            endIcon={<ArrowDropDownIcon fontSize="small" />}
            sx={{
              textTransform: "none",
              ml: 1,
              display: "flex",
              alignItems: "center",
              color: "inherit",
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "0.875rem",
                maxWidth: 100, // ← ajuste ici la largeur max
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "inherit",
              }}
            >
              {nameProfile}
            </Typography>
          </Button>
        )}
        <Menu
          anchorEl={anchorProfile}
          open={Boolean(anchorProfile)}
          onClose={handleProfileClose}
          PaperProps={{
            style: {
              minWidth: 160,
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
          }}
        >
          <MenuItem
            onClick={() => {
              handleProfileClose();
              navigate("/app/userprofile");
            }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PersonIcon fontSize="small" />
                  {translate("Profile")}
                </Box>
              }
            />
          </MenuItem>

          {!isPremium && (
            <MenuItem
              onClick={() => {
                handleProfileClose();
                navigate("/app/gotopremium");
              }}
            >
              <ListItemText
                primary={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <StarIcon fontSize="small" />
                    {translate("GoPremium")}
                  </Box>
                }
              />
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleProfileClose();
              setOpenLogoutConfirm(true);
            }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ExitToAppIcon fontSize="small" />
                  {translate("Logout")}
                </Box>
              }
            />
          </MenuItem>
        </Menu>
      </Box>

      <Dialog
        open={openLogoutConfirm}
        onClose={() => setOpenLogoutConfirm(false)}
      >
        <DialogTitle>{translate("ConfirmLogout")}</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpenLogoutConfirm(false)}>
            {translate("Cancel")}
          </Button>
          <Button
            onClick={async () => {
              setOpenLogoutConfirm(false);
              await logOut();
              navigate("/login");
            }}
            color="error"
          >
            {translate("Logout")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
